import gql from "graphql-tag";

const LIST_SHOP_CAMPAIGNS = gql`
  query ListShopCampaigns($userId: ID!, $nextToken: String) {
    campaigns(userId: $userId, nextToken: $nextToken) {
      nextToken
      list {
        id
        name
        active
        createdAt
        updatedAt
        target {
          type
          selected {
            id
            image
            title
            handle
          }
          ids
          countries {
            include_active
            include
            exclude_active
            exclude
          }
        }
      }
    }
  }
`;

export default LIST_SHOP_CAMPAIGNS;
